import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Divider,
  Typography,
  Stack,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForwardOutlined";
import { lowerCase } from "lodash";
import { useTheme } from "@mui/system";
import CustomButton from "../CustomButton";
import cssVariables from "../../utils/cssVariables";
import { COLORS } from "../../constants";
import { formatDisplayName } from "../../utils/helpers";

const TopbarShopByCategoryDrawer = ({
  categoriesAndTypes,
  mobileCategoriesDrawerOpen,
  mobileTypesDrawerOpen,
  selectedCategory,
  toggleCategories,
  toggleTypes,
  handleCategoryClick,
  handleCloseTypesClick,
}) => {
  const theme = useTheme();
  const sortedCategories = [...categoriesAndTypes].sort((a, b) =>
    a.productCategoryName.localeCompare(b.productCategoryName)
  );

  return (
    <>
      <Drawer
        anchor="left"
        open={mobileCategoriesDrawerOpen}
        onClose={toggleCategories}
        sx={{
          width: "75%",
          "& .MuiDrawer-paper": {
            width: "75%",
            boxSizing: "border-box",
            backgroundColor: `${COLORS.background} !important`,
          },
        }}
      >
        <Stack
          direction="column"
          sx={{
            borderRadius: 0,
            borderBottom: `1px solid ${COLORS.border}`,
            justifyContent: "center",
            marginBottom: "1rem",
            position: "sticky",
            top: 0,
            zIndex: 1100,
            boxShadow: "none",
            backgroundColor: COLORS.white,
          }}
        >
          <Box
            sx={{ alignItems: "left", paddingTop: "1rem" }}
            onClick={toggleCategories}
          >
            <CustomButton
              text="Menu"
              startIcon={<ArrowBackIcon fontSize="small" />}
              color={cssVariables.blueButtonColor}
              basic
            />
          </Box>
          <Box sx={{ alignItems: "left", paddingLeft: "1rem" }}>
            <Typography
              sx={{ fontSize: "var(--font-size-xs)", fontWeight: 500 }}
              gutterBottom
            >
              Shop by Category
            </Typography>
          </Box>
        </Stack>

        <Paper
          sx={{
            width: "100%",
            overflowY: "auto",
            borderRadius: 0,
            boxShadow: "none",
            mt: 1,
          }}
        >
          <List
            sx={{
              py: `0 !important`,
            }}
          >
            {sortedCategories.map((category, j) => {
              return (
                <div key={j}>
                  <ListItemButton
                    href="#"
                    onClick={() => handleCategoryClick(category)}
                    sx={{ borderBottom: `1px solid ${COLORS.background}` }}
                  >
                    <ListItemText
                      primary={formatDisplayName(category.productCategoryName)}
                      sx={{
                        "& .MuiTypography-root": {
                          fontSize: "var(--font-size-xxs)",
                        },
                      }}
                    />
                    <IconButton sx={{ flexShrink: 0 }} edge="end">
                      <ArrowForwardIcon fontSize="small" />
                    </IconButton>
                  </ListItemButton>
                </div>
              );
            })}
          </List>
        </Paper>
      </Drawer>

      {!!selectedCategory && (
        <Drawer
          anchor="left"
          open={mobileTypesDrawerOpen}
          onClose={handleCloseTypesClick}
          sx={{
            width: "75%",
            "& .MuiDrawer-paper": {
              width: "75%",
              boxSizing: "border-box",
              backgroundColor: `${COLORS.background} !important`,
            },
          }}
        >
          <Stack
            direction="column"
            sx={{
              borderRadius: 0,
              borderBottom: `1px solid ${COLORS.border}`,
              justifyContent: "center",
              marginBottom: "1rem",
              position: "sticky",
              top: 0,
              zIndex: 1100,
              boxShadow: "none",
              backgroundColor: COLORS.white,
            }}
          >
            <Box
              sx={{ alignItems: "left", paddingTop: "1rem" }}
              onClick={handleCloseTypesClick}
            >
              <CustomButton
                text="Shop by category"
                startIcon={<ArrowBackIcon fontSize="small" />}
                color={cssVariables.blueButtonColor}
                basic
              />
            </Box>
            <Box sx={{ alignItems: "left", paddingLeft: "1rem" }}>
              <Typography
                sx={{ fontSize: "var(--font-size-s)", fontWeight: 500 }}
                gutterBottom
              >
                {formatDisplayName(selectedCategory?.productCategoryName)}
              </Typography>
            </Box>
          </Stack>
          <Paper
            sx={{
              width: "100%",
              overflowY: "auto",
              borderRadius: 0,
              boxShadow: "none",
              mt: 1,
            }}
          >
            <List
              sx={{
                py: `0 !important`,
              }}
            >
              {[...selectedCategory.productTypes]
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((type, j) => {
                const typeSlug =
                  lowerCase(type.name) === "view all"
                    ? `/products/${selectedCategory.productCategoryId}`
                    : `/products/${selectedCategory.productCategoryId}/${type.productTypeId}`;

                return (
                  <div key={j}>
                    <ListItemButton
                      href={typeSlug}
                      sx={{ borderBottom: `1px solid ${COLORS.background}` }}
                    >
                      <ListItemText
                        primary={formatDisplayName(type.name)}
                        sx={{
                          "& .MuiTypography-root": {
                            fontSize: "var(--font-size-xxs)",
                          },
                        }}
                      />
                    </ListItemButton>
                  </div>
                );
              })}
            </List>
          </Paper>
        </Drawer>
      )}
    </>
  );
};

export default TopbarShopByCategoryDrawer;
